/// <amd-module name="Environments/EnvironmentDetails/Components/EnvironmentChecksComponent" />
import React = require("react");

import * as Contracts from "DistributedTask/Client/Contracts/TaskAgent";

import { ChecksOverview } from "Checks/ChecksOverview/ChecksOverview";

import { EnvironmentChecksActionsCreator, EnvironmentChecksPageKey } from "ActionsCreators/EnvironmentChecksActionsCreator";
import { EnvironmentsSource } from "Source/EnvironmentsSource";
import { EnvironmentChecksStore } from "Stores/EnvironmentChecksStore";

import { EnvironmentBaseComponent, IEnvironmentBaseComponentProperties, IEnvironmentBaseComponentState } from "Environments/EnvironmentsCommon/EnvironmentBaseComponent";
import { getCurrentEnvironmentIdFromRoute } from "Environments/EnvironmentsCommon/Link";
import { ActionCreatorManager } from "Environments/Flux/ActionCreatorManager";
import { StoreManager } from "Environments/Flux/StoreManager";

import { IVssComponentContext, IVssComponentProperties, VssComponent } from "VSS/Platform/Layout";

import { Page } from "VSSUI/Page";
import { Surface, SurfaceBackground } from "VSSUI/Surface";

export interface IEnvironmentChecksComponentState extends IEnvironmentBaseComponentState {
    environment: Contracts.EnvironmentInstance | undefined;
}

export class EnvironmentChecksComponent extends EnvironmentBaseComponent<IEnvironmentBaseComponentProperties, IEnvironmentChecksComponentState> {

    public constructor(props: IVssComponentProperties, context: IVssComponentContext) {
        super(props, context);
        let environmentId = getCurrentEnvironmentIdFromRoute(context.pageContext);

        this._environmentId = environmentId;
        this.state = {
            environment: undefined,
            errorMessages: {}
        };

        if (this._environmentId) {
            this._actionCreator = ActionCreatorManager.CreateActionCreator<EnvironmentChecksActionsCreator>(EnvironmentChecksActionsCreator, this.getInstanceId(context));
            this._store = StoreManager.CreateStore<EnvironmentChecksStore>(EnvironmentChecksStore, this.getInstanceId(context));
            this._store.addChangedListener(this._onEnvironmentChecksStoreChange);
            this._actionCreator.getEnvironmentById(this.context.pageContext, this._environmentId, false);
            this._source = EnvironmentsSource.getInstance(context.pageContext);
            this._hasManagePermision = this._source.checkAdminPermission(this._environmentId.toString());
        }
    }

    public getInstanceId(context: IVssComponentContext): string {
        return "environment-checks-id-" + this.componentId;
    }

    public render(): JSX.Element {
        return (
            <Surface background={SurfaceBackground.neutral}>
                <Page className="flex-grow">
                    {this._getErrorMessage()}
                    <div className="pipelines-environment-checks page-content page-content-top">
                        {!this._getErrorMessage() && this._environmentId && this._getEnvironmentChecksOverview()}
                    </div>
                </Page>
            </Surface>
        )
    }

    private _getEnvironmentChecksOverview = (): JSX.Element => {
        return (
            <ChecksOverview
                resourceType={this._environmentResourceType}
                resourceId={this._environmentId.toString()}
                resourceName={this.state.environment ? this.state.environment.name : ""}
                hasManagePermission={this._hasManagePermision} />);
    }

    private _getErrorMessage(): React.ReactNode {
        if (this._messagesStore.getMessage(EnvironmentChecksPageKey)) {
            return (
                <div className="page-content page-content-top">
                    {this.getErrorMessageView(EnvironmentChecksPageKey)}
                </div>
            )
        }
    }

    private _onEnvironmentChecksStoreChange = (): void => {
        const environment = this._store.getEnvironment();
        // Re-render the page using the acquired environment
        this.setState({ environment });
    }

    private _environmentId: number;
    private _store: EnvironmentChecksStore;
    private _actionCreator: EnvironmentChecksActionsCreator;
    private _environmentResourceType: string = "environment";
    private _hasManagePermision: boolean;
    private _source: EnvironmentsSource;
}

VssComponent.register("environmentChecksView", EnvironmentChecksComponent);
